export default "__VITE_ASSET__BgiFUohf__"